<template>
  <div class="container fill-div background-primary">
    <md-content class="md-elevation-10 center-div" :style="show == 'reset' ? 'height:500px;' : 'height:400px;'">

      <div v-if="show == 'login' || show == null">
        <div class="title">
          <img :src="logoSrc" style="max-height:40pt;" />
          <div class="md-title">Login</div>
        </div>
        <div class="form" v-on:keyup.enter="tryLogin">
          <md-field>
            <label>Gebruikersnaam</label>
            <md-input v-model="login.usr" autofocus></md-input>
          </md-field>
          <md-field md-has-password>
            <label>Wachtwoord</label>
            <md-input v-model="login.pwd" type="password"></md-input>
          </md-field>
        </div>
        <div class="md-layout md-alignment-center-space-between">
          <a @click="show = 'forgot'">Wachtwoord vergeten?</a>
          <md-button class="md-raised md-primary" @click="tryLogin" :disabled="login.usr == '' || login.pwd == ''">Log in</md-button>
        </div>
      </div>

      <div v-if="show == 'forgot'">
        <div class="title">
          <div class="md-title">Wachtwoord vergeten?</div>
        </div>
        <p>Voer uw gebruikersnaam in en klik daarna op 'resetten'. U krijgt een e-mail toegestuurd met verdere instructies.</p>
        <div class="form">
          <md-field>
            <label>Gebruikersnaam</label>
            <md-input v-model="login.usr" autofocus></md-input>
          </md-field>
        </div>
        <div class="md-layout md-alignment-center-space-between">
          <md-button @click="show = 'login'">Annuleren</md-button>
          <md-button class="md-raised md-accent" @click="trySendMail" :disabled="login.usr == ''">Resetten</md-button>
        </div>
      </div>

      <div v-if="show == 'reset'">
        <div class="title">
          <div class="md-title">Wachtwoord instellen</div>
        </div>
        <div class="form" v-on:keyup.enter="tryReset">
          <md-field v-if="reset.showToken">
            <label>Reset token</label>
            <md-input v-model="reset.token"></md-input>
          </md-field>
          <md-field>
            <label>Gebruikersnaam</label>
            <md-input v-model="login.usr" autofocus :disabled="reset.disableUserEdit"></md-input>
          </md-field>
          <md-field md-has-password>
            <label>Nieuw wachtwoord</label>
            <md-input v-model="reset.pwd1" type="password"></md-input>
          </md-field>
          <md-field md-has-password>
            <label>Herhaal wachtwoord</label>
            <md-input v-model="reset.pwd2" type="password"></md-input>
          </md-field>
          <span v-if="reset.pwd1 != reset.pwd2 && reset.pwd2 != ''" style="color:orangered;">Wachtwoorden komen niet overeen.</span>
        </div>
        <div class="md-layout md-alignment-center-space-between">
          <md-button class="md-accent" @click="show = 'login'">Annuleren</md-button>
          <md-button class="md-raised md-primary" @click="tryReset" :disabled="login.usr == '' || reset.pwd1 == '' || reset.pwd2 == '' || reset.pwd1 != reset.pwd2">Instellen</md-button>
        </div>
      </div>

      <load-overlay v-if="loading" style="position:absolute;" />

    </md-content>

    <md-snackbar :md-duration="10000" :md-active.sync="msg.show">
      <span>{{ msg.msg }}</span>
    </md-snackbar>
  </div>
</template>

<script>
  import { Events } from '@wsb/wsb-jsbase';
  import LoadOv from '@/components/LoadOverlay';

/////////////////////////
//////////////////////////////////////////////////////
//////////////////////////
//////////////////////////////////////////////////////
//////////////////////////
  var logoSrc = require('@/assets/alli/FullLogo.png');
/////////////////////////
//////////////////////////////////////////////////////
////////////

  const _login = {
    data: () => ({
      loading: false,
      show: 'login',
      msg: {
        show: false,
        msg: ''
      },
      login: {
        usr: '',
        pwd: ''
      },
      reset: {
        token: '',
        showToken: true,
        pwd1: '',
        pwd2: '',
        disableUserEdit: false
      },
      logoSrc: logoSrc
    }),
    methods: {
      tryLogin() {
        this.loading = true;
        this.login.usr = this.login.usr.trim();
        global.Auth.Login(this.login.usr, this.login.pwd)
          .then(() => {
            this.loading = false;
            localStorage.setItem('PrevUsr', this.login.usr);
            this.$emit('loggedIn');
          })
          .catch(r => {
            console.log('Login failed:', r);
            if (r.Msg != undefined) {
              this.msg.msg = r.Msg;
            } else {
              this.msg.msg = 'Login mislukt!';
            }
            this.msg.show = true;
            this.loading = false;
          });
        this.login.pwd = '';
      },
      tryReset() {
        var slf = this;
        slf.loading = true;
        new Promise((resolve, reject) => {
          fetch(global.apiUrl + "/Login/ChangePassword", {
            method: 'POST',
            headers: new Headers({
              "Content-Type": "application/json"
            }),
            body: JSON.stringify({
              Username: slf.login.usr,
              Token: slf.reset.token,
              NewPassword: slf.reset.pwd1
            })
          })
            .then(rsp => {
              if (rsp.ok || rsp.status == 204) {
                resolve();
              } else {
                rsp.text()
                  .then(reject)
                  .catch(reject);
              }
            })
            .catch(reject);
        })
          .then(() => {
            slf.loading = false;
            slf.show = 'login';
            window.history.pushState({}, null, "/#/");
          })
          .catch(e => {
            slf.loading = false;
            Events.RaiseExceptionOccurred(`Reset mislukt: ${e}`);
          });
      },
      trySendMail() {
        this.loading = true;
        fetch(global.apiUrl + "/ForgotPassword/" + this.login.usr, {
          method: 'POST'
        })
          .then(resp => resp.ok ? Promise.resolve() : Promise.reject(resp.status + " (" + resp.statusText + ")"))
          .then(() => {
            this.loading = false;
            this.msg.msg = "E-Mail verstuurd";
            this.msg.show= true;
            this.show = 'login';
          })
          .catch(e => {
            this.loading = false;
            Events.RaiseExceptionOccurred(`Reset mislukt, klopt de gebruikersnaam?\r\nFout: ${e}`);
          });
      }
    },
    created() {
      var prev = localStorage.getItem('PrevUsr');
      if (prev !== null) {
        this.login.usr = prev;
      }

      var prms = new URL(location).searchParams;
      if (prms.get("reset") === "true") {
        this.show = 'reset';

        var tok = prms.get("token");
        if (tok !== null) {
          this.reset.token = tok;
          this.reset.showToken = false;
        }
        var usr = prms.get("user");
        if (usr !== null) {
          this.login.usr = usr;
          this.reset.disableUserEdit = true;
        }
      }
    },
    components: {
      'load-overlay': LoadOv
    }
  };

  export default _login;
</script>

<style scoped lang="scss">
  .title {
    text-align: center;
    margin-bottom: 16px;
  }

  .form {
    margin-bottom: 60px;
  }

  .md-content {
    width: 350px;
    padding: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue